import { render, staticRenderFns } from "./DeliveredMailFilters.vue?vue&type=template&id=9cfcdb30"
import script from "./DeliveredMailFilters.vue?vue&type=script&lang=js"
export * from "./DeliveredMailFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports